
import getters from './getters';
import mutations from './mutations';

const state = {
  loading: false,
  status: '',
  message: '',
  errorCode: '',
  nextPage: '',
  toggleManageMembership: false,
};

const actions = {
  resetMessage({ commit }) {
    const resetState = Object.assign({}, {
      loading: false,
      status: '',
      message: '',
      errorCode: '',
    });
    commit('SET_STATUS', resetState);
  },
  setLoading({ commit }) {
    commit('TOGGLE_LOADING', true);
  },
  unsetLoading({ commit }) {
    commit('TOGGLE_LOADING', false);
  },
  setNextPage({ commit }, href = '') {
    commit('SET_NEXT_PAGE', href);
  },
  setManageMembership({ commit }, toggle) {
    commit('TOGGLE_MANAGE_MEMBERSHIP', toggle);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Notification/index.js